enum Animations {
  regular = '240ms ease-in-out',
  quick = '100ms ease-in-out'
}
export default Animations;
